import React, { useMemo } from 'react';
import {
  STTimeLineChartData,
  TimeFrame,
} from '../../../../../../../redux/monitoring/api/monitoring-ui.model';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';

interface DigitalTableProps {
  digitalChannels: STTimeLineChartData;
  timeFrame: TimeFrame;
}
function DigitalTable(props: DigitalTableProps) {
  const { digitalChannels, timeFrame } = props;
  const rows = useMemo(
    () => getDigitalRows(digitalChannels, timeFrame),
    [digitalChannels, timeFrame]
  );
  const columns = useMemo(
    () => [
      {
        field: 'timestamp',
        headerName: 'Timestamp',
        width: 200,
        renderCell: (params: any) => {
          return params.row.timestamp
            ? moment.unix(params.row.timestamp).format('L LTS')
            : '';
        },
      },
      { field: 'value', headerName: 'Value', width: 120 },
      { field: 'valueOld', headerName: 'Value old', width: 120 },
      { field: 'deviceId', headerName: 'Device ID', width: 150 },
      { field: 'deviceName', headerName: 'Device name', width: 180 },
      { field: 'eventId', headerName: 'Event ID', width: 150 },
      { field: 'eventName', headerName: 'Event name', width: 180 },
      { field: 'controlunit', headerName: 'Control unit ID', width: 150 },
      { field: 'controlunitName', headerName: 'Control unit name', width: 180 },
      { field: 'state', headerName: 'State', width: 120 },
      { field: 'stateOld', headerName: 'State old', width: 120 },
    ],
    [digitalChannels]
  );
  return (
    <DataGrid
      rows={rows}
      columns={columns}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 25 },
        },
        sorting: { sortModel: [{ field: 'timestamp', sort: 'desc' }] },
      }}
      disableRowSelectionOnClick
      pageSizeOptions={[10, 25, 50, 100, 200, 500, 1000]}
    />
  );
}

const getDigitalRows = (
  digitalChannels: STTimeLineChartData,
  timeFrame: TimeFrame
) => {
  return Object.values(digitalChannels)
    .flatMap((channel) => {
      return (
        channel.dataList?.map((dataPoint) => {
          return {
            id: `${channel.deviceId}-${channel.controlUnitId}-${channel.eventId}-${dataPoint.timestamp}`,
            timestamp: dataPoint.timestamp,
            value: dataPoint.value,
            valueOld: dataPoint.valueOld,
            deviceId: channel.deviceId,
            deviceName: channel.deviceName,
            eventId: channel.eventId,
            eventName: channel.textTranslation,
            controlunit: channel.controlUnitId,
            controlunitName: channel.controlUnitName,
            state: dataPoint.state,
            stateOld: dataPoint.stateOld,
          };
        }) ?? []
      );
    })
    .filter((row) => {
      // Filter rows based on the time frame
      if (!timeFrame) return true; // If no time frame is set, show all rows
      const rowTimestamp = moment.unix(row.timestamp);
      return (
        rowTimestamp.isSameOrAfter(timeFrame.start) &&
        rowTimestamp.isSameOrBefore(timeFrame.end)
      );
    });
};

export default DigitalTable;
